import type { BreadcrumbList, ListItem,WithContext } from "schema-dts";
import Car from "@src/interfaces/carDetails.interface";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { configApi } from "@shared/lib/configApi";
import { OfferMeta } from "@shared/lib/interfaces/car.interface";
import { RouterConfig } from "@shared/lib/routerConfig";
import { RouterSlugs } from "@shared/lib/routerSlugs";

export const getBreadcrumbProductOfferSchema = (
    car: Car,
    meta: OfferMeta,
    canonicalUrl: string
): WithContext<BreadcrumbList> => {
    const baseUrl = configApi.API_PUBLIC_DOMAIN;

    const items: ListItem[] = [];

    items.push({
        "@type": "ListItem",
        position: items.length + 1,
        item: {
            "@type": "Thing",
            "@id": baseUrl,
            name: PROJECT_NAME
        }
    });

    items.push({
        "@type": "ListItem",
        position: items.length + 1,
        item: {
            "@type": "Thing",
            "@id": `${baseUrl}${RouterConfig.CATALOG_ALL}`,
            name: "Каталог"
        }
    });

    if (meta.city?.alias && meta.city?.name) {
        items.push({
            "@type": "ListItem",
            position: items.length + 1,
            item: {
                "@type": "Thing",
                "@id": `${baseUrl}${RouterConfig.CATALOG}/${meta.city.alias}/${RouterSlugs.SLUG_FILTERS_END}`,
                name: meta.city.name
            }
        });
    }

    if (meta.brand?.alias && meta.brand?.name) {
        const cityAlias = meta.city?.alias || RouterSlugs.SLUG_ALL_CITIES;
        items.push({
            "@type": "ListItem",
            position: items.length + 1,
            item: {
                "@type": "Thing",
                "@id": `${baseUrl}${RouterConfig.CATALOG}/${cityAlias}/${meta.brand.alias}/${RouterSlugs.SLUG_FILTERS_END}`,
                name: meta.brand.name
            }
        });
    }

    items.push({
        "@type": "ListItem",
        position: items.length + 1,
        item: {
            "@type": "Thing",
            "@id": canonicalUrl,
            name: car.title ?? ""
        }
    });

    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items
    };
};